import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store/store';
import i18n from './i18n'; // Mueve la configuración de i18n a un archivo separado
import './assets/css/tailwind.css';
import './assets/scss/main.scss';

// TODO: Vuesax Component Framework
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css'; // Vuesax

// BootstrapVueNext
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './registerServiceWorker';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEraser, faMinus, faArrowLeft, faArrowUp, faBell, faCheck, faChevronDown, faChevronRight, faChevronUp, faCommentAlt, faExclamation, faExclamationCircle, faHeart, faList, faPaperclip, faPaperPlane, faPlus, faReply, faSearch, faSignInAlt, faSignOutAlt, faSmile, faStar, faThumbsDown, faThumbsUp, faTimes, faUniversity, faUserSecret } from '@fortawesome/free-solid-svg-icons';

// Lodash
import lodash from 'lodash';

// Autolinker
import autolinker, { AUTOLINKER_NAME } from 'vue-autolinker';

// Google Login
import vue3GoogleLogin from 'vue3-google-login'

// Socket.io
import getSocketConnection from './socket';
import VueSocketIOExt from 'vue-socket.io-extended';

// Crear la instancia de la aplicación
const app = createApp(App);

// Global error handler — catches unhandled errors inside Vue components
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue global error]', err, info);
};

// Global handler for unhandled promise rejections outside Vue
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '');
  // Auto-reload on chunk load errors (stale deploy)
  if (
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk')
  ) {
    event.preventDefault();
    window.location.reload();
    return;
  }
  // Suppress known SW-related errors that cannot be fixed client-side
  if (
    msg.includes('SecurityError') ||
    msg.includes('The operation is insecure') ||
    msg.includes('InvalidStateError') ||
    msg.includes('Failed to update a ServiceWorker') ||
    msg.includes('script resource is behind a redirect')
  ) {
    console.warn('[SW related error suppressed]', msg);
    event.preventDefault();
    return;
  }
  console.error('[Unhandled rejection]', event.reason);
});

// Usa Vuesax
app.use(Vuesax);

// Usa BootstrapVueNext
app.use(BootstrapVue);

// Usa FontAwesome
/*FONT AWESOME*/
library.add(faEraser, faMinus, faChevronDown, faChevronUp, faCommentAlt, faChevronRight, faUniversity, faSignOutAlt, faTimes, faBell, faHeart, faUserSecret, faSearch, faPlus, faTimes, faSignInAlt, faSignOutAlt, faExclamationCircle, faExclamation, faArrowLeft, faArrowUp, faThumbsUp, faThumbsDown, faSmile, faPaperclip, faPaperPlane, faStar, faList, faCheck, faReply);
app.component('FontAwesomeIcon', FontAwesomeIcon);

// Usa Lodash (comprobar que funciona)
app.config.globalProperties._ = lodash

// Usa Vue Autolinker
app.directive(AUTOLINKER_NAME, autolinker);

// Configura i18n
app.use(i18n);

// Configura Vue Router y Vuex Store
app.use(router);
app.use(store);

// Configura Google Login
app.use(vue3GoogleLogin, {
  clientId: '245885437889-j1sqt94jkpklii27nm0lqi419sucppc4.apps.googleusercontent.com'
})

// Configura Socket.io
let token = localStorage.getItem('k-chat-token')

if (token) {
  app.use(VueSocketIOExt, getSocketConnection(window.config.SOCKET,  localStorage.getItem('k-chat-token')));
}

// Monta la aplicación
app.mount('#app');
export default app;